module.exports = __webpack_public_path__ + "static/media/infinityHpSign.38b13958.svg";